import { Listbox as HeroUiListbox, ListboxItem as HeroUiListboxItem } from '@heroui/listbox';

export const Listbox = HeroUiListbox;
export const ListboxItem = HeroUiListboxItem;
